import { DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { TimeoutWarningModalConfig } from './timeout-modal.models';

export class KeepaliveErrorConfig {
  /** handles redirecting to an internal route */
  route?: string;

  /** handles redirecting to an external link */
  link?: string;

  constructor(options = {}) {
    Object.assign(this, options);
  }
}

export enum authUserLoggedInUser {
  appUserData = 'appUserData',
}

export class IdleConfig {
  enabled = false;
  timeToIdle = 1200; // 20 minutes
  timeoutAfterIdle = 300; // 5 minutes
  interrupts: any[] = DEFAULT_INTERRUPTSOURCES;
  redirectAfterLogoutUrl?: string;
  body!: string;
  title!: string;
  btn_continue!: string;
  btn_logout!: string;

  constructor(options = {}) {
    Object.assign(this, options);
  }
}

export class KeepaliveConfig {
  endpoint = 'user/keep-alive/';
  enabled = true;
  interval = 15;
  error: KeepaliveErrorConfig;

  constructor(
    options: KeepaliveConfig = {
      interval: null,
      error: null,
      enabled: null,
      endpoint: null,
    },
  ) {
    Object.assign(this, options || {});

    this.error = new KeepaliveErrorConfig(this.error || {});
  }
}

export class TimeoutConfig {
  idle?: IdleConfig;
  keepalive?: KeepaliveConfig;
  timeoutWarningModal?: TimeoutWarningModalConfig;

  constructor(options: TimeoutConfig = { idle: null, keepalive: null }) {
    this.idle = new IdleConfig(options.idle);
    this.keepalive = new KeepaliveConfig(options.keepalive);
    this.timeoutWarningModal = new TimeoutWarningModalConfig(
      options.timeoutWarningModal,
    );
  }
}

export enum IdleStates {
  Not_Idle = 'No longer idle',
  Started = 'Started',
  Timeout = "You've gone idle",
  TimeoutWarning = 'You will time out in ${countdown} seconds',
}
